import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import AppDao from '../../data/AppDao';
import { useUserDerivedBounds } from '../../GoogleMapV4/hooks/useUserDerivedBounds';
export const DevWeather = ({}) => {
    const { userDevice: { userDevicePosition: devicePosition }, } = useUserDerivedBounds({});
    const params = {
        location: devicePosition,
    };
    const getWeatherForecast = async () => {
        const res = await AppDao.getWeatherForecastByLatLng(params);
        if (res.data) {
            setWeatherForecast(res.data.weatherData);
        }
        else {
            setError(res.err);
        }
    };
    const [weatherForecast, setWeatherForecast] = useState(undefined);
    const [error, setError] = useState(null);
    useEffect(() => {
        getWeatherForecast();
    }, []);
    return _jsx("div", { children: JSON.stringify(weatherForecast ?? error ?? {}) });
};
